export const environment = {
  env: 'dev',
  production: true,
  apiHost: 'https://api.dev.pelletdose.co/',
  frontHost: 'https://dev.pelletdose.co/',
  inviteRout: 'sign-up?token=',
  resetPassword: 'reset-password?token=',
  dsn: 'https://28904cb3a6885be6020574c044c030bd@o4510756043882496.ingest.de.sentry.io/4510986090315856',
  replayEnabled: false,
  tawkToAccountId: '5e56bded298c395d1ce9f885',
  freshWorkId: '154000001417',
  serviceWorker: {
    enabled: true,
    checkInterval: 1 * 60 * 1000, // check every 1 minutes for dev env only
    autoReloadDelay: 3 * 60 * 1000, // 3 minutes for auto-reload
    enableDetailedLogs: true,
  },
};
